import React from 'react';
import qp from 'query-parse';

import { showCreateProjectModal } from '../actions/projects';

import { isMac } from 'services/env-service';
import { openWindow } from '../utils';
import { buildAppUrl } from '../utils/url';
import { browserHistory } from './history';
import { showModal } from '../actions/modal';

let updateCompleted = false;
let hasUpdateError = false;

export const emit = (name, ...args) => {
    if (window.ipcRenderer) {
        window.ipcRenderer.send(name, ...args);
    }
}

export const onceElectronEvent = (name, callback) => {
    if (window.ipcRenderer) {
        window.ipcRenderer.once(name, callback);
    }
}

export const onElectronEvent = (name, callback) => {
    if (window.ipcRenderer) {
        window.ipcRenderer.on(name, callback);
    }
}

export const openElectronHelperBrowser = ({ params = {}, windowProps, onMessage }) => {
    const key = new Date().getTime().toString();
    const winParams = {
        ...params,
        key
    };

    const messageHandler = event => {
        if (event.data && typeof event.data === 'object') {
            if (!event.data.key) {
                if (event.data.action === 'LOAD') {
                    sendInit();
                }
            } else if (event.data.key === key) {
                if (event.data.action === 'REJECT') {
                    destroy();
                } else {
                    onMessage(event.data)
                }
            }
        }
    }

    const sendInit = () => {
        win.postMessage({
            action: 'INIT',
            payload: winParams
        });
    }

    const win = openWindow(buildAppUrl(`/electron-helper-browser?${qp.toString(winParams)}`), windowProps, 'electron-helper-browser');

    const destroy = () => {
        window.removeEventListener('message', messageHandler, false);

        try {
            win && win.close();
        } catch (e) {}
    }

    window.addEventListener('message', messageHandler, false);

    return destroy;
}

export const requestMediaAccess = type => {
    return new Promise((resolve, reject) => {
        onceElectronEvent('requestMediaAccessResult', (event, result) => {
            if (!result) {
                reject(new Error('No permissions'));
            } else {
                resolve();
            }
        });

        emit('requestMediaAccess', type);
    });
}

const getProjectIdFromUrl = () => browserHistory.location.pathname.match(/^(.*?)\//)[1];

const updateHandlers = [];
export const registerUpdateChange = callback => {
    updateHandlers.push(callback);
}

const broadcastUpdateChange = ({ status, props }) => {
    updateHandlers.forEach(handler => handler(status, props));
}

if (window.ipcRenderer) {
    window.ipcRenderer.on('innerRedirect', (sender, url) => {
        browserHistory.push(url);
    });

    window.ipcRenderer.on('update-available', () => {
        broadcastUpdateChange({ status: 'available' });
    });

    window.ipcRenderer.on('update-progress', (sender, params) => {
        if (hasUpdateError || updateCompleted) {
            return;
        }

        if (Math.round(params.percent) === 100) {
            broadcastUpdateChange({ status: 'completed' });
            return;
        }

        broadcastUpdateChange({
            status: 'progress',
            props: {
                percent: params.percent
            }
        });
    });

    window.ipcRenderer.on('update-downloaded', () => {
        updateCompleted = true;
        broadcastUpdateChange({ status: 'completed' });
    });

    window.ipcRenderer.on('update-error', () => {
        hasUpdateError = true;
        broadcastUpdateChange({ status: 'error' });
    });

    window.ipcRenderer.on('action', (sender, action) => {
    });

    window.ipcRenderer.on('uiAction', (sender, action, ...args) => {
        switch (action) {
            case 'showOverview':
                browserHistory.push(`/overview`);
                break;

            case 'invitePeople':
                browserHistory.push(`/settings/team/current/people`);
                break;

            case 'createProject':
                showCreateProjectModal();
                break;

            case 'createTask':
                showModal('CREATE_TASK', {
                    name: args[0],
                    projectId: getProjectIdFromUrl()
                });
                break;

            case 'createDoc':
                showModal('DOC_CREATE', {
                    name: '',
                    projectId: getProjectIdFromUrl()
                });
                break;

            case 'uploadFile':
                browserHistory.push(`/${getProjectIdFromUrl()}/files/upload`);
                break;

            default:
                return;
        }
    });
}
